









































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import ChannelGroupAddChannelModal from "@/components/channels/modals/ChannelGroupAddChannelModal.vue";
// types
import { ChannelGroupChannel, ChannelGroupChannelDrag } from "@/services/channels/types";
import { channelGroupsChannelsFields } from "@/components/channels/fields/channelGroupsFields";
import ChannelInfoModal from "@/components/channels/modals/ChannelInfoModal.vue";
// validation
import validate from "@/directives/validate";

@Component({
    components: {
        "channelGroup-addChannels-modal": ChannelGroupAddChannelModal,
        "channel-info-modal": ChannelInfoModal
    },
    directives: {
        validate
    }
})
export default class ChannelGroupChannels extends Vue {
    @Prop() channels!: ChannelGroupChannel[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localChannels = [] as ChannelGroupChannelDrag[];
    fields = channelGroupsChannelsFields;
    validators = {};
    order = 0;
    sortBy = "order";
    sortDesc = true;
    // Watchers
    @Watch("channels")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localChannels = this.channels.map((x: ChannelGroupChannel) => ({
            channelId: x.channelId,
            channelName: x.channelName,
            width: x.width,
            height: x.height,
            folderId: x.folderId,
            showTime: x.showTime,
            order: x.order,
            selected: true,
            active: false,
            activeDropTarget: false
        }));
        this.localChannels.forEach(x => { x.selected = true; x.order = this.localChannels.indexOf(x); });
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }

    // computed

    // methods
    addChannel() {
        (this.$refs.channelGroupAddChannelModal as any).open();
    }

    addChannelGroupChannels(selectedChannels: Array<ChannelGroupChannel>) {
        if (selectedChannels.length > 0) {
            this.order = Math.max.apply(Math, selectedChannels.map(function (o) { return o.order ? o.order : 0; }));
        }
        this.localChannels = [];
        selectedChannels.forEach(x => {
            this.localChannels.push({
                channelId: x.channelId,
                channelName: x.channelName,
                width: x.width,
                height: x.height,
                folderId: x.folderId,
                showTime: x.showTime,
                order: x.order,
                selected: true,
                active: false,
                activeDropTarget: false
            } as ChannelGroupChannelDrag);
        });
    }

    channelInfo(channelId: string) {
        (this.$refs.channelInfoModal as any).open(channelId);
    }

    previewChannel(channelId: string) {
        var routeData = this.$router.resolve({ name: "channelPreview", params: { channelId: channelId } });
        window.open(routeData.href, "_blank");
    }

    goToChannelRoute(channelId: string) {
        return { name: "updatechannel", params: { channelId: channelId } };
    }

    deleteChannel(id: string) {
        const item = this.localChannels.find(x => x.channelId === id);
        if (!item) {
            return;
        }
        this.localChannels.splice(this.localChannels.indexOf(item), 1);
        this.localChannels.forEach(x => { x.order = this.localChannels.indexOf(x); });
        this.emitData();
    }

    // events && callbacks
    channelSelected(channels: any) {
        this.addChannelGroupChannels(channels);
    }

    emitData() {
        // deep copy to avoid binding
        var data = JSON.parse(JSON.stringify(this.localChannels));
        data.forEach((x: any) => { x.order = data.indexOf(x) + 1; });
        this.$emit("channelGroupChannelsUpdated", data);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "ChannelGroupChannels", state: state });
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setData(
            "id",
            event.target.id
        );
        event.dataTransfer.setData(
            "type",
            "channel"
        );
    }

    dragLeave(event: any) {
        const target = Object.assign({}, this
            .localChannels
            .find(x => event.currentTarget && x.channelId === event.currentTarget.id));
        if (!target) return;
        target.activeDropTarget = false;
    }

    dragOver(event: any) {
        event.preventDefault();
        const target = Object.assign({}, this
            .localChannels
            .find(x => event.currentTarget && x.channelId === event.currentTarget.id));
        if (!target) return;
        if (target.active) return;
        target.activeDropTarget = true;
    }

    dragEnd() {
        this.localChannels.forEach(x => {
            x.activeDropTarget = false;
            x.active = false;
        });
    }

    reorder(event: any) {
        event.preventDefault();
        if (!event.currentTarget.id) {
            return;
        }

        const target = Object.assign({}, this
            .localChannels
            .find(x => event.currentTarget && x.channelId === event.currentTarget.id));
        const source = Object.assign({}, this
            .localChannels
            .find(x => event.dataTransfer && x.channelId === event.dataTransfer.getData("id")));
        if (!(source.channelId && target.channelId)) { return; }
        this.localChannels.forEach(x => {
            // move array posts according direction up or down
            if (target.order > source.order && x.channelId !== source.channelId) {
                this.arrayMove(this.localChannels, x.order, x.order--);
            } else if (target.order < source.order && x.channelId !== source.channelId) {
                this.arrayMove(this.localChannels, x.order, x.order++);
            }
            // set source item on place of target item
            if (x.channelId === source.channelId) {
                this.arrayMove(this.localChannels, x.order, target.order);
                x.order = target.order;
            }
        });
        this.localChannels.forEach(x => { x.order = this.localChannels.indexOf(x); });
    }

    arrayMove(arr: any, oldIndex: number, newIndex: number) {
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        return arr;
    };
}
